import React from 'react';
import { Row, Col } from 'react-bootstrap';

import channeling from '../assets/img/channeling.jpg'
import img1 from "../assets/img/bandeau.jpg";

export const Channeling = () => {
    return (
        <>

            <div className="banner-titre-container">
                <img src={img1} className="back-img" />
                <div className='over-banner'>
                    <div className='info-banner'>
                        <h1 className='banner-title'> Channeling ... votre âme, vos Guides vous parlent</h1>
                    </div>
                </div>
            </div>


            <div className='block-container bottom-space side-space-margin top-space-margin'>
                <Row>
                    <Col xs={12} lg={8}>
                        <div className='central-block'>
                            <h2 className='meditation-titre'>Au Fond de Vous, un Univers d'Amour</h2>
                            <p align="center">&nbsp;</p><br />
                            <p>Lors d’une séance de Channeling Spirituel, je capte les messages qui émergent de cet univers à votre intention personnelle.</p><br />
                            <p>Qu’on les nomme intuition, voix de l’âme ou message des Guides de Lumière,  les mots-énergies, puisés auprès de la Source, enclenchent un moment de <strong>retrouvailles</strong> avec votre <strong>Moi profond</strong>.
                                C’est un moment privilégié de mise en résonnance avec Qui vous êtes vraiment dans votre pleine potentialité.</p><br />
                            <p>Image après image, métaphore après métaphore, vous êtes <strong>réconforté</strong> et <strong>éclairé</strong> sur le sens de votre existence, ainsi que sur vos challenges et votre mission personnelle. Les informations transmises, souvent avec <strong>humour </strong>et <strong>douceur</strong>, suscitent un sentiment de <strong>libération</strong> intérieure.</p><br />
                            <p>Si nécessaire, des passages délicats de votre vie sont revisités et dénoués. D’éventuelles <strong>mémoires</strong> résiduelles sont <strong>pacifiées</strong> puis <strong>transmutées</strong> grâce à la puissance de l'Amour qui guérit.</p><br />
                            <p>Rapidement, vous ressentez que vos cellules, en affinité naturelle avec ces vibrations spirituelles élevées, se remplissent d’<strong>énergie</strong> et d’<strong>espoir</strong>. Vous serez plus centré, plus vivant, régénéré.</p><br />
                            <p>Le Channeling Spirituel est <strong>respectueux</strong> du <strong>rythme</strong> ainsi que de l’étape de <strong>développement</strong> de chacun. Il agit sur le physique, le mental, l'émotionnel et le spirituel et prend soin de vous sur tous les plans.</p><br />
                        </div>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className='right-block'>
                            <h2 align="center"><img src={channeling} className="channeling-img" /></h2>
                            <br />
                            <p class="style1"><strong>Livre d'Or :</strong></p>
                            <ul class="style1">
                                <li>"C'est un moment unique où notre vie profonde s'éclaire dans les zones de l'âme que l'intellect ne peut régler ..." </li><br />
                                <li>"C'est une renaissance de l'âme et un apaisement du subconscient ..."</li><br />
                                <li>"Merci de m'avoir permis de retrouver ma vraie famille, ma famille d'âme, je me sentais si seule ..."</li><br />
                                <li>"Merci, merci, merci, quelle émotion !"</li><br />
                                <li>"Merci pour mon ami, il est transformé ..."</li><br />
                                <li>"Il y a la vie d'avant ... et la vie  d'après la séance !"</li><br />
                                <li>"J'ai retrouvé mes yeux, je comprends tout mieux maintenant ..."</li><br />
                                <li>"C'est mieux qu'une prise de conscience, c'est une <em>prise ...d'âme !</em>"</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

